import React, { useRef, useEffect, useState } from "react";
import { getMaxZIndexInContainer } from "Jarvis/JarvisServices/JarvisHtmlService";
import { FullscreenOutlined, FullscreenExitOutlined } from "@material-ui/icons";
import "./css.css";
const MainContainer = React.forwardRef(({ children }, ref) => {
  const [stateObj, setStateObj] = useState({
    height: 0,
    fullScreen: false,
    maxZIndex: 0,
  });
  const internalRef = useRef();
  const targetRef = ref || internalRef;
  useEffect(() => {
    const top = targetRef.current ? targetRef.current.offsetTop : 65;
    const footer = document.querySelector(".app-footer");
    const restHeight =
      window.innerHeight - top - (footer && footer.offsetHeight);
    const mZIndex = getMaxZIndexInContainer();
    setStateObj((prev) => ({
      ...prev,
      height: restHeight-60,
      maxZIndex: mZIndex,
    }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onClickFullScreen = () => {
    setStateObj((prev) => ({ ...prev, fullScreen: !prev.fullScreen }));
  };

  const generateStyle = () => {
    let style = { height: stateObj.height,marginTop:"0px",paddingTop:"0px" };
    if (stateObj.fullScreen) {
      style.zIndex = stateObj.maxZIndex + 1;
      style.height = window.height;
      style.padding = 0;      
    }
    return style;
  };

  return (
    <div
      className={`app-wrapper  ${stateObj.fullScreen === true ? "fullscreen-container" : ""
        }`}
      ref={targetRef}
      style={generateStyle()}
    >
      <div className="animated slideInUpTiny animation-duration-1" style={{height:"100%"}}>
        {/* <i
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1,
            cursor: "pointer",
          }}
          onClick={onClickFullScreen}
        >
          {stateObj.fullScreen ? (
            <FullscreenExitOutlined titleAccess="Exit Full Screen" />
          ) : (
            <FullscreenOutlined titleAccess="Full Screen" />
          )}
        </i> */}
        {children}
      </div>
    </div>
  );
});
export default MainContainer;
